// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_gNW","cls2":"SuggestedContentSidebar-cls2_YqQ SuggestedContentSidebar-cls1_gNW"};